import * as React from "react";
import { Container } from "@grandvisionhq/elements";
import { H2 } from "@grandvisionhq/iris-ui";
import { RecommendationsGallery } from "../../../../../RecommendationsGallery/lib-components/RecommendedProducts/components/RecommendationsGallery/RecommendationsGallery.js";
/* empty css                                       */
const RecommendationsGalleryPageSection = ({ title, recommendations }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "recommendations-gallery-page-section" }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(H2, null, title), /* @__PURE__ */ React.createElement(RecommendationsGallery, { recommendations })));
};
export {
  RecommendationsGalleryPageSection
};
//# sourceMappingURL=RecommendationsGalleryPageSection.js.map
